/* eslint-disable indent */
import {
  SET_CHAT_SCHEDULES,
  SET_CHAT_REQUESTS,
  SET_CHAT_MEETINGS,
  SET_CHAT_USER,
  SET_USERS_MESSAGES,
  SET_CHAT_CATEGORY_OPEN,
  SET_CHAT_MEETING_DATA,
  SET_CHAT_MEETING_NOTIFICATIONS,
  SET_LAST_MESSAGE_ID,
  SET_UPDATE_MESSAGE,
  SET_IS_MOBILE,
  SET_GET_CHATS,
  SET_CHAT_NOTIFICATION,
  SET_USER_FROM_ID,
} from './constants'

export const initialState = {
  chatSchedules: [],
  chatRequests: [],
  chatMeetings: [],
  chatUser: {},
  usersMessages: [],
  openCategoryChat: '',
  meeting: {},
  meetingNotifications: {},
  lastId: '',
  updateMessage: {},
  isMobile: window.innerWidth < 1280,
  getChatsUpdate: false,
  typeNotification: {},
  userFromId: {},
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_CHAT_SCHEDULES:
      return { ...state, chatSchedules: payload }
    case SET_CHAT_REQUESTS:
      return { ...state, chatRequests: payload }
    case SET_CHAT_MEETINGS:
      return { ...state, chatMeetings: payload }
    case SET_CHAT_USER:
      return { ...state, chatUser: payload }
    case SET_USERS_MESSAGES:
      return { ...state, usersMessages: payload }
    case SET_CHAT_CATEGORY_OPEN:
      return { ...state, openCategoryChat: payload }
    case SET_CHAT_MEETING_DATA:
      return { ...state, meeting: payload }
    case SET_CHAT_MEETING_NOTIFICATIONS:
        return { ...state, meetingNotifications: payload }
    case SET_LAST_MESSAGE_ID:
        return { ...state, lastId: payload }
    case SET_UPDATE_MESSAGE:
        return { ...state, updateMessage: payload }
    case SET_IS_MOBILE:
        return { ...state, isMobile: payload }
    case SET_GET_CHATS:
        return { ...state, getChatsUpdate: payload }
    case SET_CHAT_NOTIFICATION:
        return { ...state, typeNotification: payload }
    case SET_USER_FROM_ID:
        return { ...state, userFromId: payload }
    default:
      return state
  }
}
